import React from 'react';
export default (props) => React.createElement("h1", null,
    " ",
    props.title,
    " ");
